import { ReportOptionsDto } from "@api-types/reports/ReportOptionsDto";
import {
	AccountActivityReviewReportDto,
	BettingActivityReviewReportDto,
	ReportResultDto,
} from "@api-types/reports/ReportResultDto";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { RequestContextType } from "@utils/api-config/RequestContext";
import { createApiRequestOptions } from "@utils/api-config/createApiRequestOptions";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ContextOptions, ApiRequestContextData } from "@utils/api-config/types";
import { DateTime } from "luxon";

export default class ReportInsightsApiService {
	static baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/report-insights`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type"] = "application/json";
		appHeaders["Accept"] = "application/json";

		return appHeaders;
	};

	static async fetchUserBettingActivity(
		filter: ReportOptionsDto,
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Default
		)
	): Promise<ReportResultDto<BettingActivityReviewReportDto>> {
		const context = getApiRequestContext(options);
		const headers = this.getRequestHeaders(context);

		return await httpClient.post(
			`${this.baseUrl()}/BettingActivityReview`,
			JSON.stringify(filter),
			headers
		);
	}

	static async fetchUserAccountActivity(
		filter: ReportOptionsDto,
		options: ContextOptions = createApiRequestOptions(
			RequestContextType.Default
		)
	): Promise<ReportResultDto<AccountActivityReviewReportDto>> {
		const context = getApiRequestContext(options);
		const headers = this.getRequestHeaders(context);
		return await httpClient.post(
			`${this.baseUrl()}/AccountActivityReview`,
			JSON.stringify(filter),
			headers
		);
	}

	static getMyBetsReport(
		startDate: string,
		endDate: string,
		bettingAccountTypeAbrv: string,
		options: ContextOptions
	) {
		const context = getApiRequestContext(options);

		const headers = this.getRequestHeaders(context);
		var filter = {
			filter: {
				accessChannels: {
					Agencies: null,
					Shops: [
						{
							AgencyId: context?.agencyId,
							Id: context?.shopId,
						},
					],
				},
				parameters: [
					{
						column: "StartDate",
						value: startDate,
					},
					{
						column: "EndDate",
						value: endDate,
					},
					{
						column: "BettingAccountTypeAbrv",
						value: bettingAccountTypeAbrv,
					},
				],
			},
			timeZoneName: DateTime.local().zoneName,
		};
		return httpClient.post(
			this.baseUrl() + "/mybets",
			JSON.stringify(filter),
			headers
		);
	}
}
